<template>
  <div class="new-section-wrapper no-print">
    <div class="new-section is-flex is-pulled-left">
      <a class="button is-primary has-text-weight-bold has-text-white is-uppercase"
         :disabled="disabled"
         tabindex="0"
         @keypress.enter.space="toggle"
         @click="toggle"
         qa="new-section">
        <i class="far fa-plus" />&nbsp;{{ newSection }} <span v-if="!isMobile && $i18n.locale === 'en'"
                                         class="is-upperase">&nbsp;{{ section }}</span>
      </a>
    </div>
  </div>
</template>
<script>
import breakpoints from '@/libs/breakpoints'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    attributes: {
      type: String
    },
    newSection: {
      type: String,
      required: true
    },
    section: {
      type: String,
      required: true
    }
  },
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .new-section {
    height: 100%;
    align-items: center;
    justify-content: center;
    color: $grey-dark;
    letter-spacing: .05rem;
    a {
      width: 130px;
      font-size: 0.65rem;
      border-radius: 0;
      @include mobile {
        width: 80px;
      }
    }
    .button[disabled] {
      pointer-events: none;
    }
  }
</style>
